export default (to, from, next) => {
  console.log('auth')
  next()
  const userInfo = window.localStorage.getItem('userInfo')
  const fingerprint = window.localStorage.getItem('fingerprint')
  if (userInfo != null && userInfo.length > 0 && fingerprint != null) {
    next()
  } else {
    console.log('auth redirect')
    window.localStorage.removeItem('userInfo')
    next('/app/sessions/signIn')
  }
}
